import React, { useEffect, useState } from 'react';
import './Dash.css'
import SideMenu from '../Components/Layout/SideMenu';
import TopBar from '../Components/Layout/TopBar';
import StatCard from '../Components/Common/StatCard';

import Events from '../Assets/Icons/Events.svg'
import Bookings from '../Assets/Icons/Bookings.svg'
import Revenue from '../Assets/Icons/Revenue.svg'
import Users from '../Assets/Icons/Users.svg'
import { supabase } from '../supabase';
import RecentBookingsTable from '../Components/Common/RecentBookingsTable';
import RecentEventsTable from '../Components/Common/RecentEventsTable';

const Dash = () => {
    const [events, setEvents] = useState([]);
    const [bookings, setBookings] = useState([]);
    const [users, setUsers] = useState([]);
    const [payments, setPayments] = useState([]);
    const [totalRevenue, setTotalRevenue] = useState(0);

    useEffect(()=>{
        const getEvents =async () => {
            const res = await supabase.from('Events').select('*');
            setEvents(res.data)
        }

        getEvents();
    } , [])

    useEffect(()=>{
        const getBookings = async () => {
            const res = await supabase.from('Bookings').select('*');
            setBookings(res.data);
        }

        getBookings();
    } , [])

    useEffect(()=>{
        const getUsers = async () => {
            const res = await supabase.from('Users').select('*');
            setUsers(res.data);
            console.log(res)
        }

        getUsers();
    } , [])

    useEffect(()=>{
        const getPayments = async () => {
            const { data } = await supabase.from('Payments').select('amount');
            setPayments(data);
            console.log(data)

            const total = (data || []).reduce((sum, item) => {
            return sum + Number(item.amount || 0);
        }, 0);

        setTotalRevenue(total);
        }

        getPayments();
    } , [])


    return ( <main>
        <SideMenu />

        <div className='DashMain'>
            <TopBar PageTitle='Events' />

            <div className='DashContent'>
                <div className='StatCards'>
                    <StatCard SCardName="Total Events" SCardNum={events.length} SCardIcon={Events}/>
                    <StatCard SCardName="Total Bookings" SCardNum={bookings.length} SCardIcon={Bookings}/>
                    <StatCard SCardName="Total Revenue" SCardNum={"$" + Math.ceil(totalRevenue)} SCardIcon={Revenue}/>
                    <StatCard SCardName="Active Users" SCardNum={users.length} SCardIcon={Users}/>
                </div>

                <div className='RecentTables'>
                    <RecentBookingsTable RTableName="Recent Bookings"/>
                    <RecentEventsTable RTableName="Latest Events"/>
                </div>
                
            </div>
        </div>
    </main> );
}
 
export default Dash;<>

</>